module.exports = __webpack_public_path__ + "fd9db3736cfc3a2bd85fed420c3f8894.png";